import axios from "axios";
import settings from "../settings";
import { userTranslationFunctions } from "@/mixins/user-translation-functions";
import moment from "moment";

const exportColumns = {};

let new_shop_data = {
    is_new: true,
    name: null,
    store_id: null,
    type: null,
    image: null,
    comment: null,
    address: null,
    address_place: null,
    address_parish: null,
    address_county: null,
    address_country: "EE",
    latitude: null,
    longitude: null,
    additional_field: null,
    codes: [],
    store: {
        company_name: null
    },
    contacts: []
};
let new_contact_data = {
    name: null,
    position: null,
    phone: null,
    email: null,
    additional_field: null
};
const new_code_data = {
    id: `X${Math.round(Math.random() * 10000)}`,
    code: null,
    partner: "smarten"
};
const listSettingsColumns = [
    {
        value: "name",
        text: "Name",
        align: "left",
        isSelected: true
    },
    {
        value: "company_name",
        text: "Company name",
        align: "left",
        isSelected: false
    },
    {
        value: "identification_code",
        text: "Identification code",
        align: "left",
        isSelected: false
    },
    {
        value: "chain_name",
        text: "Chain name",
        align: "left",
        isSelected: false
    },
    {
        value: "type",
        text: "Type",
        align: "left",
        isSelected: true
    },
    {
        value: "address",
        text: "Address",
        align: "left",
        isSelected: true
    },
    {
        value: "address_place",
        text: "City",
        align: "left",
        isSelected: true
    },
    {
        value: "address_parish",
        text: "Parish",
        align: "left",
        isSelected: false
    },
    {
        value: "address_county",
        text: "County",
        align: "left",
        isSelected: false
    },
    {
        value: "eugesta_codes",
        text: "Eugesta code",
        align: "left",
        isSelected: false
    },
    {
        value: "smarten_codes",
        text: "Smarten code",
        align: "left",
        isSelected: false
    },
    {
        value: "turnover",
        text: "Turnover",
        align: "left",
        isSelected: false
    }
];
let initialState = {
    exportMode: false,
    exportModal: false,
    exportProducts: [],
    exportColumns: exportColumns,
    loadingShopList: false,
    loadingShopData: false,
    requestSuccess: false,
    requestError: false,
    errorMessage: "",
    drawerOpen: false,
    activeShop: {},
    shops: [],
    stores: [],
    searchShopString: "",
    imageFile: null,
    files: [],
    tableOptions: null,
    totalShopsCount: 0,
    mergeShops: [],
    chartType: "month",
    listSettingsModal: false,
    listSettingsColumns: listSettingsColumns,
    shopsAdminTableHeaders: [],
    startDate: new Date(2020, 0, 1),
    endDate: new Date()
};
let cancelDataRequest = null;
export default {
    namespaced: true,
    state: { ...initialState },
    mixins: [userTranslationFunctions],
    actions: {
        async getShopsList({ commit }, { options = null, search = null, start_date = null, end_date = null }) {
            commit("setShopListLoading", true);
            if (cancelDataRequest) {
                cancelDataRequest();
            }
            const CancelToken = axios.CancelToken;
            let params = {
                search: search ? search : "",
                page: options && options.page ? options.page : null,
                itemsPerPage: options && options.itemsPerPage ? options.itemsPerPage : null,
                sortBy: options && options.sortBy[0] ? options.sortBy[0] : null,
                sortDesc: options && options.sortDesc ? options.sortDesc[0] : null,
                start_date: start_date ? start_date : null,
                end_date: end_date ? end_date : null
            };
            try {
                let response = await axios.get(settings.api_url + "/shops-admin", {
                    params,
                    cancelToken: new CancelToken(c => {
                        cancelDataRequest = c;
                    })
                });
                if (response.status === 200) {
                    cancelDataRequest = null;
                    let data = response.data;
                    commit("addShops", data.shops);
                    commit("setShopListLoading", false);
                    commit("setTotalShopsCount", data.total_shops_count);
                    if (data.user_shops_admin_search_settings) {
                        commit("setMountedTableHeaders", data.user_shops_admin_search_settings);
                    } else {
                        commit("setShopsAdminTableHeaders");
                    }
                }
            } catch (e) {
                console.log(e);
                commit("setShopListLoading", false);
            }
        },
        async callGetShopsList({ state, dispatch }) {
            await dispatch("getShopsList", {
                options: state.tableOptions,
                search: state.searchShopString,
                start_date: state.startDate ? moment(state.startDate).format("YYYY-MM-DD") : null,
                end_date: state.endDate ? moment(state.endDate).format("YYYY-MM-DD") : null
            });
        },
        async importExcel({ commit, dispatch }, e) {
            commit("setShopListLoading", true);

            let formData = new FormData();
            formData.append("file", e);
            commit("setRequestSuccess", false);
            commit("setRequestError", false);
            try {
                let response = await axios.post(settings.api_url + "/shops-excel/", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                });
                if (response.status === 200) {
                    if (response.data.success === 1) {
                        commit("setRequestSuccess", true);
                    } else {
                        commit("setRequestError", true);
                        commit("setErrorMessage", response.data.error_msg);
                    }
                }
            } catch (e) {
                console.log(e);
            }
            await commit("setShopListLoading", false);
            await dispatch("callGetShopsList");
        },
        async getShopData({ commit }, shopId) {
            commit("setShopDataLoading", true);
            try {
                let response = await axios.get(settings.api_url + "/shop/" + shopId);
                if (response && response.data && response.status === 200) {
                    let data = response.data;
                    commit("setActiveShop", data.shop_data);
                }
                commit("setShopDataLoading", false);
            } catch (e) {
                console.log(e);
                commit("setShopDataLoading", false);
            }
        },
        async getStores({ commit }) {
            try {
                let response = await axios.get(settings.api_url + "/stores/");

                if (response && response.data && response.status === 200) {
                    let data = response.data;
                    commit("setStores", data.stores);
                }
                commit("setShopDataLoading", false);
            } catch (e) {
                console.log(e);
                commit("setShopDataLoading", false);
            }
        },
        async submitShopUpdate({ commit, dispatch }, { shop, image }) {
            commit("setShopDataLoading", true);
            let formData = new FormData();
            formData.append("file", image);
            formData.append("data", JSON.stringify(shop));

            commit("setRequestSuccess", false);
            commit("setRequestError", false);
            try {
                let response = await axios.post(settings.api_url + "/shop/", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                });
                if (response.status === 200) {
                    if (response.data.success === 1) {
                        commit("setRequestSuccess", true);
                        commit("setShopDataLoading", false);
                        return { status: 1, id: response.data.product_id };
                    } else {
                        commit("setRequestError", true);
                        commit("setErrorMessage", response.data.error_msg);
                        commit("setShopDataLoading", false);
                        return { status: 0 };
                    }
                }
            } catch (e) {
                console.log(e);
            }
            commit("setShopDataLoading", false);
        },
        async deleteProduct({ commit, dispatch }, { shop_id }) {
            commit("setRequestSuccess", false);
            try {
                const response = await axios.delete(settings.api_url + "/shop/", {
                    params: { shop_id }
                });

                if (response.status === 200) {
                    commit("setRequestSuccess", true);
                    return { status: 1 };
                } else {
                    return { status: 0 };
                }
            } catch (e) {
                console.log(e);
            }
        },
        async getMergeShops({ commit, state }) {
            commit("setShopDataLoading", true);
            try {
                let response = await axios.get(settings.api_url + "/merge-shops/" + state.activeShop.id);

                if (response && response.data && response.status === 200) {
                    let data = response.data;
                    commit("setMergeShops", data.shops);
                }
                commit("setShopDataLoading", false);
            } catch (e) {
                console.log(e);
                commit("setShopDataLoading", false);
            }
        },
        async sendMergeShops({ commit }, payload) {
            commit("setShopDataLoading", true);
            commit("setRequestError", false);
            commit("setRequestSuccess", false);
            try {
                let response = await axios.post(settings.api_url + "/merge-shops/", payload);
                commit("setShopDataLoading", false);
                if (response && response.data) {
                    return response.data;
                }
                return false;
            } catch (e) {
                console.log(e);
                commit("setShopDataLoading", false);
            }
        }
    },
    getters: {
        shopsCount: state => {
            return state.shops.length;
        }
    },
    mutations: {
        setTableOptions(state, options) {
            state.tableOptions = options;
            this.dispatch("ShopsAdminStore/callGetShopsList");
        },
        setTotalShopsCount(state, count) {
            state.totalShopsCount = count;
        },
        setImageFile(state, payload) {
            state.imageFile = payload.value;
            if (payload.value === undefined) {
                state.imageFile = null;
                state.activeShop.image = null;
                state.activeShop.image_path = null;
            }
        },
        setRequestSuccess(state, bool) {
            state.requestSuccess = bool;
        },
        setRequestError(state, bool) {
            state.requestError = bool;
        },
        setErrorMessage(state, msg) {
            state.errorMessage = msg;
        },
        addShops(state, products) {
            state.shops = products;
        },
        setActiveShop(state, shop) {
            state.activeShop = { ...shop };
        },
        toggleDrawer(state, isOpen) {
            state.drawerOpen = isOpen;
        },
        resetActiveShop(state) {
            state.activeShop = {};
        },
        addNewProduct(state) {
            state.activeShop = new_shop_data;
        },
        updateActiveShopProperty(state, { prop, value }) {
            state.activeShop = {
                ...state.activeShop,
                [prop]: value
            };
        },
        updateActiveShopStoreProperty(state, { prop, value }) {
            state.activeShop.store = {
                ...state.activeShop.store,
                [prop]: value
            };
        },
        updateActiveShopContactProperty(state, { prop, value, index }) {
            state.activeShop.contacts[index] = {
                ...state.activeShop.contacts[index],
                [prop]: value
            };
        },
        updateActiveProductJsonField(state, { prop, value }) {
            state.activeShop.data = {
                ...state.activeShop.data,
                [prop]: value
            };
        },
        updateShopSearch(state, payload) {
            state.searchShopString = payload.term;
            this.dispatch("ShopsAdminStore/callGetShopsList");
        },
        resetShopSearch(state) {
            state.searchShopString = "";
        },
        setShopListLoading(state, value) {
            state.loadingShopList = value;
        },
        addNewShopContact(state) {
            state.activeShop.contacts.push(new_contact_data);
        },
        deleteShopContact(state, index) {
            state.activeShop.contacts.splice(index, 1);
        },

        setStores(state, value) {
            state.stores = value;
        },
        setShopDataLoading(state, value) {
            state.loadingShopData = value;
        },
        setMergeShops(state, value) {
            state.mergeShops = value;
        },
        setChartType(state, value) {
            state.chartType = value;
        },
        toggleListSettingsModal(state) {
            state.listSettingsModal = !state.listSettingsModal;
        },
        toggleListSettingsColumn(state, item) {
            let column = state.listSettingsColumns.find(c => c.value === item.value);
            column.isSelected = !column.isSelected;
        },
        setShopsAdminTableHeaders(state) {
            state.shopsAdminTableHeaders = [];
            state.listSettingsColumns.map(x => {
                if (x.isSelected) {
                    x.align = "left";
                    state.shopsAdminTableHeaders.push(x);
                }
            });
            let length = state.shopsAdminTableHeaders.length;
            if (length > 2) {
                state.shopsAdminTableHeaders[length - 1].align = "center";
                state.shopsAdminTableHeaders[length - 2].align = "end";
            }
        },
        setMountedTableHeaders(state, value) {
            state.shopsAdminTableHeaders = value;
            let selected_array = state.shopsAdminTableHeaders.map(x => x.value);
            state.listSettingsColumns.forEach(x => {
                x.isSelected = selected_array.includes(x.value);
            });
        },
        setStartDate(state, value) {
            state.startDate = moment(value).toDate();
            this.dispatch("ShopsAdminStore/callGetShopsList");
        },
        setEndDate(state, value) {
            state.endDate = moment(value).toDate();
            this.dispatch("ShopsAdminStore/callGetShopsList");
        },
        addNewShopCode(state) {
            state.activeShop.codes.push({ ...new_code_data, id: `X${Math.round(Math.random() * 10000)}` });
        },
        updateActiveShopCodeProperty(state, { prop, value, index }) {
            state.activeShop.codes[index] = {
                ...state.activeShop.codes[index],
                [prop]: value
            };
        },
        deleteShopCode(state, index) {
            state.activeShop.codes.splice(index, 1);
        }
    },
    methods: {}
};
